//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import seguroEmpateMixin from '~/mixins/seguro-empate'

export default {
  name: 'ElementsSeguroEmpateBadge',
  mixins: [seguroEmpateMixin],
  props: {
    event: {
      default: null
    },
    variant: {
      type: String,
      default: 'compact'
    },
    interactive: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showTooltip: false
    }
  },
  computed: {
    eligible() {
      return this.seguroEmpateEligible(this.event)
    }
  },
  mounted() {
    if (!this.interactive) return
    this._onDocumentClick = (event) => {
      if (!this.showTooltip) return
      const wrapper = this.$refs.wrapper
      if (wrapper && !wrapper.contains(event.target)) {
        this.showTooltip = false
      }
    }
    document.addEventListener('click', this._onDocumentClick)
  },
  beforeDestroy() {
    if (this._onDocumentClick) {
      document.removeEventListener('click', this._onDocumentClick)
    }
  },
  methods: {
    toggleTooltip() {
      if (!this.interactive) return
      this.showTooltip = !this.showTooltip
    }
  }
}
